import { useIsMobile } from "../../hooks/state-checkers/use-is-mobile";
import { useApolloClient, useQuery } from "@apollo/client";
import { NOTIFICATION_SUBSCRIPTION } from "../../components/layout/header/notifications/subscriptions";
import React, { useRef } from "react";
import { ArrowLeft } from "../../components/common/arrow";
import { FormattedMessage } from "react-intl";
import { NotificationComponent } from "../../components/notifications/notification-component";
import { PrimarySpinner } from "../../components/spinner/primary-spinner";
import settings from "../../img/edit_icon.svg";
import styled from "styled-components";
import { useOpenClose } from "../../hooks/use-open-close";
import {
  GET_NOTIFICATIONS,
  GET_COURSE_TEACHINGS,
} from "../../apollo-client/queries";

export const HomePageNotificationsBox = () => {
  const client = useApolloClient();

  const {
    data: dataNotifications,
    loading: loadingNotifications,
    error: errorNotifications,
    fetchMore: fetchMoreNotifications,
    subscribeToMore: subscribeToMoreNotifications,
  } = useQuery(GET_NOTIFICATIONS, {
    variables: { limit: 15 },
  });

  subscribeToMoreNotifications({
    document: NOTIFICATION_SUBSCRIPTION,
    updateQuery: async (prev, { subscriptionData }) => {
      if (!subscriptionData.data) return prev;

      const newNotification = subscriptionData.data.newNotification;

      if (newNotification.notificationType === "newTeaching") {
        await client.refetchQueries({ include: [GET_COURSE_TEACHINGS] });
      }

      return Object.assign({}, prev, {
        user: {
          ...prev.user,
          notifications: [newNotification, ...prev.user.notifications],
        },
      });
    },
  });

  const scrollRef = useRef(null);

  const handleScroll = async () => {
    const { current } = scrollRef;
    if (
      !loadingNotifications &&
      current.scrollTop + current.clientHeight >= current.scrollHeight &&
      dataNotifications.user.notifications.length <
        dataNotifications.user.notificationsCount
    ) {
      await fetchMoreNotifications({
        variables: {
          limit: 15,
          skip: dataNotifications.user.notifications.length,
        },
      });
    }
  };

  return (
    <NotificationBox>
      <HeadlineBox>
        <Headline>
          <FormattedMessage id="abo-notifications.notifications" />
        </Headline>
      </HeadlineBox>
      <NotificationContainer ref={scrollRef} onScroll={handleScroll}>
        {!errorNotifications &&
          dataNotifications &&
          dataNotifications?.user?.notifications?.map(
            (notification, i, notifications) => (
              <NotificationComponent
                key={"notification_" + i}
                notification={notification}
                prevNotification={notifications[i - 1]}
                setIsNotificationsMenuOpen={() => {}} //Its always open on the homepage, so this function can ignored
                skip={dataNotifications.user.notifications.length}
              />
            )
          )}
        {loadingNotifications && (
          <SpinnerWrapperFetchMore>
            <PrimarySpinner />
          </SpinnerWrapperFetchMore>
        )}
      </NotificationContainer>
      {loadingNotifications && (
        <SpinnerWrapper>
          <PrimarySpinner />
        </SpinnerWrapper>
      )}
      {!errorNotifications &&
        dataNotifications?.user?.notifications?.length === 0 && (
          <CenterText>
            Abonniere Module komplett, oder Teilbereiche, oder stelle Fragen und
            lass sie beantworten
          </CenterText>
        )}
    </NotificationBox>
  );
};

const HeadlineBox = styled.div`
  display: flex;
  padding-left: 10px;
`;

const Headline = styled.div`
  margin: 15px;
  font-weight: 600;
  font-size: 19px;
  line-height: 26px;

  color: #383838;
`;

const NotificationBox = styled.div`
  position: relative;
  right: 100px;
  display: flex;
  flex-direction: column;
  width: 130%;
  
  height: 500px;
  
  box-shadow: -1px 2px 5px rgba(0, 0, 0, 0.3);
  border-radius: 20px;
  background-color: #fff;

  @media only screen and (max-width: ${(props) =>
    props.theme.firstBreakpoint}px) {
    width: 100%;
    height: 100vh;
    top: 0;
    left:0;
    margin-left: 0px;
  ;
`;

const Line = styled.div`
  width: 80%;
  border-bottom: 0.5px solid #a7a6a6;
`;

const NotificationContainer = styled.div`
  overflow-y: scroll;

  &::-webkit-scrollbar-track {
    border-radius: 10px;
    background-color: transparent;
  }

  &::-webkit-scrollbar {
    width: 10px;
    background-color: transparent;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: transparent;
  }

  &:hover {
    &::-webkit-scrollbar-track {
      -webkit-box-shadow: transparent;
      border-radius: 10px;
      background-color: transparent;
    }

    &::-webkit-scrollbar {
      width: 10px;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 10px;
      -webkit-box-shadow: transparent;
      background-color: lightgrey;
    }
  }
`;

const SpinnerWrapperFetchMore = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50px;
`;

const SpinnerWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
`;

const CenterText = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  margin: 0 auto;
  width: 70%;
  height: 100%;
`;

const EmailSettingsBox = styled.div`
  margin-top: auto;
  padding-left: 54px;
  display: flex;
  flex-direction: column;
`;

const EmailSettingsButton = styled.div`
  display: flex;
  align-items: center;
  padding: 10px;

  font-weight: 500;
  font-size: 18px;
  cursor: pointer;
`;

const SettingsIcon = styled.img`
  width: 20px;
  height: 20px;
  margin-right: 10px;
`;
